// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1hrhk","unreadBadge":"styles_unreadBadge__3x6f3","modalContent":"styles_modalContent__3Huec","modal":"styles_modal__2jlzz"};